import React from "react";
import styled from "styled-components";
import { Repeater, types } from "react-bricks/frontend";
import TextBlock from "../common/TextBlock";
import { LogoWallImageProps } from "../landing-page-bricks/LogoWallImage";
import { color } from "@styles";

interface LogoSectionProps {
  items: types.RepeaterItems<LogoWallImageProps>;
  logoSize: number;
  logoTitle: string;
}

export const LogoSection: types.Brick<LogoSectionProps> = ({ items, logoSize }) => {
  return (
    <Wrapper>
      <TitleWrapper>
        <TextBlock
          propName="logoTitle"
          placeholder="Trusted by:"
          renderBlock={({ children }) => <>{children}</>}
        />
      </TitleWrapper>

      <LogoWrapper>
        <Repeater
          propName="items"
          items={items}
          itemProps={{
            maxHeight: logoSize,
          }}
        />
      </LogoWrapper>
    </Wrapper>
  );
};

LogoSection.schema = {
  name: "logo-section",
  label: "Logo Section",
  category: "Logo Section Components",
  // Define repeaters for child bricks
  repeaterItems: [
    {
      name: "items",
      itemType: "logo-wall-image",
      itemLabel: "Logos",
      min: 1,
      max: 8,
    },
  ],
  // Define default props
  getDefaultProps: () => ({
    items: [],
    logoSize: 50,
    logoTitle: "Trusted by:",
  }),
  // Define side edit props
  sideEditProps: [],
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2.5rem;
`;

const TitleWrapper = styled.div`
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: ${color.B1100};
`;

const LogoWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 2rem;
  row-gap: 1.5rem;
  margin: 1rem 0;
  padding-left: 1rem;
`;
